import React, { useEffect } from "react";
import { motion } from "framer-motion";

const Gallary = () => {
  const [loading, setLoading] = React.useState(true);
  useEffect(() => {
    // Create and append the script tag for Picflow
    if (!window.picflow) {
      window.picflow = true;
      const script = document.createElement("script");
      script.src = "https://picflow.com/embed/main.js";
      script.type = "module";
      script.defer = true;
      document.head.appendChild(script);
      script.onload = () => {
        setLoading(false);
      };
    }
  }, []);

  return (
    <>
      <picflow-gallery
        style={{ zIndex: "-1" }}
        id="gal_5gesnUu7s5tfQAVe"
        tenant="tnt_KaEAbDNoYLLiE0u6"
        no-padding="true"
        no-background="true"
      ></picflow-gallery>
    </>
  );
};

export default Gallary;
